import React from 'react';
import { CameraIcon } from 'lucide-react';
interface ProjectImageSlotProps {
  src?: string;
  alt: string;
  className?: string;
}

/** 16:9 project image. Shows a deliberate placeholder until an approved photograph is supplied. */
export function ProjectImageSlot({
  src,
  alt,
  className = ''
}: ProjectImageSlotProps) {
  if (src) {
    return <div className={`relative aspect-video w-full overflow-hidden bg-charcoal-800 ${className}`} data-id="element-318" data-mp="2a7lur32sttmz">
        <img src={src} alt={alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-319" data-mp="36xw60fp07z58" />
      </div>;
  }
  return <div role="img" aria-label={`Placeholder for ${alt}. An approved project photograph will be added.`} className={`relative flex aspect-video w-full flex-col items-center justify-center overflow-hidden bg-charcoal-800 ${className}`} data-id="element-320" data-mp="2y2yad0uh28a7">
      <span className="absolute right-0 top-0 h-0 w-0 border-l-[64px] border-t-[64px] border-l-transparent border-t-brand-red" aria-hidden="true" data-id="element-321" data-mp="3qlvhxtvb1cc8" />
      <span className="absolute bottom-0 left-0 h-[3px] w-16 bg-brand-red" aria-hidden="true" data-id="element-322" data-mp="113oi5kkj9ter" />
      <CameraIcon className="h-8 w-8 text-steel-400" aria-hidden="true" data-id="element-323" data-mp="16057gi3gydtf" />
      <span className="mt-3 font-display text-[13px] font-bold uppercase tracking-[0.24em] text-steel-300" data-id="element-324" data-mp="salaxu0hecsk">
        Project image
      </span>
    </div>;
}